export default __webpack_public_path__ + "static/media/icon_logout.44bdd6eb.svg";